import React from 'react';
import { Trash2 } from 'lucide-react';
import { DetailPanel, MetadataItem } from '../DetailPanel/DetailPanel';

export interface SidebarFormProps {
  /** Title displayed in the form header */
  title: string;
  /** Called when the close (X) button is clicked */
  onClose: () => void;
  /** Label for the primary submit button */
  submitLabel: string;
  /** Called when the submit button is clicked */
  onSubmit?: () => void;
  /** Disables the submit button (e.g. while saving) */
  submitDisabled?: boolean;
  /** Whether to show the red delete button next to submit */
  showDelete?: boolean;
  /** Called when the delete button is clicked */
  onDelete?: () => void;
  /** Whether delete button is disabled */
  deleteDisabled?: boolean;
  /** Tooltip to display when delete is disabled */
  deleteDisabledTooltip?: string;
  /** The form field groups — rendered inside the <form> body */
  children: React.ReactNode;
  /** Optional metadata rows displayed below the form */
  metadata?: MetadataItem[];
  /** Title for the metadata section (e.g. "Metadatos", "Métricas_Rendimiento") */
  metadataTitle?: string;
  /** Additional class name for the outer container */
  className?: string;
  /** Optional click handler on the outer container (e.g. stopPropagation) */
  onClick?: (e: React.MouseEvent) => void;
  /** Drawer de alto completo con botón de expandir (ver DetailPanel) */
  drawer?: boolean;
  /** Botón de expandir sin ser drawer (ver DetailPanel) */
  expandable?: boolean;
}

/** Panel de detalle en modo formulario: DetailPanel con guardar y borrar al pie. */
export const SidebarForm = ({
  title,
  onClose,
  submitLabel,
  onSubmit,
  submitDisabled = false,
  showDelete = false,
  onDelete,
  deleteDisabled = false,
  deleteDisabledTooltip,
  children,
  metadata,
  metadataTitle,
  className,
  onClick,
  drawer,
  expandable,
}: SidebarFormProps) => (
  <DetailPanel
    as="form"
    onSubmit={onSubmit}
    title={title}
    onClose={onClose}
    metadata={metadata}
    metadataTitle={metadataTitle}
    className={className}
    onClick={onClick}
    drawer={drawer}
    expandable={expandable}
    footer={
      <div className="sidebar-form-actions">
        {/* type="submit": Enter en un campo también guarda, y el navegador
            valida antes los campos required/min del formulario. */}
        <button
          type="submit"
          className="sidebar-form-submit"
          disabled={submitDisabled}
        >
          {submitLabel}
        </button>
        {showDelete && (
          <button
            type="button"
            className={`sidebar-form-delete ${deleteDisabled ? 'sidebar-form-delete-disabled' : ''}`}
            title={deleteDisabled ? (deleteDisabledTooltip || 'No permitido') : 'Eliminar'}
            disabled={deleteDisabled}
            onClick={deleteDisabled ? undefined : onDelete}
          >
            <Trash2 size={18} />
          </button>
        )}
      </div>
    }
  >
    {children}
  </DetailPanel>
);
